import clsx from "clsx";
import React from "react";

import { cn } from "utils/cn";

export const Tag = ({
  text,
  active,
  onClick,
  classTag = "",
}: {
  text: string;
  classTag?: string;
  active: boolean;
  onClick: () => void;
}) => {
  return (
    <div
      className={clsx(
        "flex cursor-pointer items-center justify-center rounded-3xl border border-gray px-4 py-1 text-s",
        {
          "bg-gray text-white": active,
          "bg-white text-gray": !active,
        },
        classTag
      )}
      onClick={onClick}
    >
      <span>{text}</span>
    </div>
  );
};

export const TagSelect = ({
  options,
  value,
  label,
  onChange,
  className,
  classTag,
}: {
  options: string[];
  value: string;
  label: string;
  onChange: (selectedOptions: string) => void;
  className?: string;
  classTag?: string;
}) => {
  const handleClick = (option: string) => {
    onChange(option);
  };

  return (
    <div className={cn("flex items-center justify-center gap-4", className)}>
      <p className="text-s">{label}</p>
      <div className="flex gap-1">
        {options.map((option) => (
          <Tag
            key={option}
            text={option}
            active={option === value}
            onClick={() => handleClick(option)}
            classTag={classTag}
          />
        ))}
      </div>
    </div>
  );
};
